/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { Screen } from '@banking/ui/workflows/card-settings/billing-address';
import assert from '@banking/ui/utils/assert';
let Index = (_class = class Index extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Screen", Screen);
    _initializerDefineProperty(this, "addressValidation", _descriptor, this);
  }
  setAddressValidation(addressValidation) {
    this.addressValidation = addressValidation;
  }
  onSave() {
    assert(this.addressValidation != null);
    this.addressValidation.onClick();
  }
  get editAddressDescriptionKey() {
    if (this.args.currentScreen === Screen.EDIT_ADDRESS_FOR_REPLACEMENT_CARD) {
      return 'banking.checking.cardSettings.billingAddress.description.replacementCardAddress';
    } else {
      return 'banking.checking.cardSettings.billingAddress.description.default';
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "addressValidation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setAddressValidation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setAddressValidation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSave", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSave"), _class.prototype), _class);
export { Index as default };